import { parsePhoneNumber } from "libphonenumber-js";

export const usePhoneNumber = (
  number: number
): [formatted: string, url: string] => {
  const parsed = parsePhoneNumber(number.toString(), "US");

  return [parsed.formatInternational(), parsed.getURI()];
};
